/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

exports.__esModule = true;
exports['default'] = reducer;
exports.open = open;
exports.close = close;
var OPEN = 'baltimorebrew.com/subscribeModal/OPEN';
var CLOSE = 'baltimorebrew.com/subscribeModal/Close';
var TOGGLE = 'baltimorebrew.com/subscribeModal/TOGGLE';

var initialState = {
	isOpen: false
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case OPEN:
			{
				return {
					isOpen: true
				};
			}
		case CLOSE:
			{
				return {
					isOpen: false
				};
			}
		case TOGGLE:
			{
				var isOpen = state.isOpen;

				return {
					isOpen: !isOpen
				};
			}
		default:
			{
				return state;
			}
	}
}

function open() {
	return {
		type: OPEN
	};
}

function close() {
	return {
		type: CLOSE
	};
}
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/subscribeModal.js
 ** module id = 124
 ** module chunks = 0
 **/